import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { config } from '../../config/const';
import './MyStories.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const MyStories = () => {
  const [activeTab, setActiveTab] = useState('public');
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(false);
  // const email = localStorage.getItem('email');
  const navigate = useNavigate();

  useEffect(() => {
    fetchStories();
  }, [activeTab]);

  const fetchStories = async () => {
    try {
      setLoading(true);
      const baseUrl = config?.backend_url || 'http://localhost:3002';
      const email = localStorage.getItem('email');

      // Single API call to get all stories
      const response = await axios.get(`${baseUrl}/user/getStories?email=${email}`);
      const allStories = response.data.stories || [];
      
      // Filter stories based on activeTab
      const filteredStories = allStories.filter(story => story.status === activeTab);
      setStories(filteredStories);

    } catch (error) {
      console.error('Error fetching stories:', error);
      setStories([]);
    } finally {
      setLoading(false);
    }
  };

  const handleStoryClick = (storyId) => {
    navigate(`/story/${storyId}`);
  };

  return (
    <div className="my-stories-container">
      <div className="tabs">
        <button 
          className={`tab ${activeTab === 'public' ? 'active' : ''}`}
          onClick={() => setActiveTab('public')}
        >
          Public Stories
        </button>
        <button 
          className={`tab ${activeTab === 'private' ? 'active' : ''}`}
          onClick={() => setActiveTab('private')}
        >
          Private Stories
        </button>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loader"></div>
          <p>Loading stories...</p>
        </div>
      ) : (
        <div className="stories-content">
          {stories && stories.length > 0 ? (
            stories.map((story) => (
              <div 
                key={story._id} 
                className="story-card"
                onClick={() => handleStoryClick(story._id)}
              >
                <img src={story.thumbnail} alt={story.title} />
                <div className="story-info">
                  <h3>{story.title}</h3>
                  <div className="story-stats">
                    <span>👁️ {story.views || 0}</span>
                    <span>❤️ {story.likes || 0}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-stories-container">
              <p className="no-stories">
                {loading ? 'Loading...' : 'No stories found'}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MyStories;